import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { AssetVersionPipe } from '../../../pipes/asset-version.pipe';

@Component({
  selector: 'app-notification',
  imports: [AssetVersionPipe],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      state('visible', style({ opacity: 1 })),
      transition('void => visible', animate(300, style({ opacity: 1 }))),
      transition('visible => void', animate(300, style({ opacity: 0 })))
    ])
  ]
})
export class NotificationComponent {
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() description: string = '';

  animationState = 'void';
  isVisible = true;

  ngOnInit() {
    this.animationState = 'visible';
  }

  onClose() {
    this.animationState = 'void';
  }

  onAnimationDone(event: any) {
    if (event.toState === 'void') {
      this.isVisible = false;
    }
  }
}